import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDDNcGOtVwMdtd7vXdZ0M7TXnDZlHLU3h0",
  authDomain: "odummy-christmas.firebaseapp.com",
  projectId: "odummy-christmas",
  storageBucket: "odummy-christmas.appspot.com",
  messagingSenderId: "624998687430",
  appId: "1:624998687430:web:03e62d9ce862b35a3f2dc7",
  measurementId: "G-ZSFNKTS781",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db2026 = getFirestore(app, "ar2026");
export const db2025 = getFirestore(app, "ar2025");
export const db = db2026;
export const storage = getStorage(app);

export default app;
